export default __webpack_public_path__ + "settings-icon.33fe17a6d768745ef5ca5cb6955d4a01.svg";